export const REDUCER_NAME = 'upload'




// WEBPACK FOOTER //
// ./src/modules/payment/state/upload/const.js